"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
const countries_1 = require("../../countries");
const utils_1 = require("@loadsure/utils");
const coverageOption_1 = __importDefault(require("../coverageOption"));
const coverageOptionItem_1 = __importDefault(require("../coverageOptionItem"));
const coverageRate_1 = __importDefault(require("../coverageRate"));
class CoverageDefinition {
    constructor(coverageId, name, options, rates, minPremium, defaultLimit, minDeductible, assuredCountries, currencies, termsAndConditions) {
        this.coverageId = coverageId;
        this.name = name;
        this.options = options;
        this.rates = rates;
        this.minPremium = minPremium;
        this.defaultLimit = defaultLimit;
        this.minDeductible = minDeductible;
        this.assuredCountries = assuredCountries;
        this.currencies = currencies;
        this.termsAndConditions = termsAndConditions;
    }
    static fromObj(data) {
        const options = data.options.map(coverageOption_1.default.fromObj);
        const rates = data.rates.map(coverageRate_1.default.fromObj);
        if (!options.some((option) => option.id === "accountId")) {
            const optionAccountIds = new Set();
            rates
                .flatMap((rate) => rate.optionRestrictions.accountId)
                .filter(utils_1.isObjectDefined)
                .forEach((accountId) => optionAccountIds.add(accountId));
            if (optionAccountIds.size) {
                const items = [
                    ...Array.from(optionAccountIds).map((accountId) => coverageOptionItem_1.default.fromObj({
                        id: accountId,
                        name: accountId
                    }))
                ];
                const accountOption = new coverageOption_1.default("accountId", "Account", __1.eCoverageOptionType.DROP_DOWN, items);
                options.unshift(accountOption);
            }
        }
        options.forEach((option) => {
            option.items.forEach((item) => {
                var _a, _b, _c, _d;
                if ((_a = item.restrictions) === null || _a === void 0 ? void 0 : _a.pickup) {
                    item.restrictions.pickup = countries_1.getCountryIdsForLocationsOrGroups((_b = item.restrictions) === null || _b === void 0 ? void 0 : _b.pickup);
                }
                if ((_c = item.restrictions) === null || _c === void 0 ? void 0 : _c.delivery) {
                    item.restrictions.delivery = countries_1.getCountryIdsForLocationsOrGroups((_d = item.restrictions) === null || _d === void 0 ? void 0 : _d.delivery);
                }
            });
        });
        const assuredCountries = data.assuredCountries
            ? countries_1.getCountryCodesForLocationsOrGroups(data.assuredCountries)
            : [];
        const accountOption = options.find((option) => option.id === "accountId");
        if (accountOption) {
            accountOption.items.unshift(coverageOptionItem_1.default.fromObj({
                id: "",
                name: "N/A"
            }));
        }
        const hasHVSReferral = rates.some((rate) => rate.costCalcs.some((costCalc) => !!costCalc.referral));
        if (!hasHVSReferral) {
            const hvsRate = coverageRate_1.default.fromObj({
                costCalcs: [
                    {
                        minLimit: {
                            value: 750000,
                            type: ">="
                        },
                        referral: "HIGH_VALUE_SHIPMENT"
                    }
                ],
                zIndex: 20
            });
            rates.unshift(hvsRate);
        }
        return new CoverageDefinition(data.coverageId, data.name, options, rates, data.minPremium, data.defaultLimit, data.minDeductible, assuredCountries, data.currencies, data.termsAndConditions);
    }
}
exports.default = CoverageDefinition;
//# sourceMappingURL=coverageDefinition.class.js.map